import React, { useEffect, useState, useMemo } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Card } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { Table, Input } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { updateMenuData } from "../../store/slices/misc/menuData";
import TopMenu from "../../route/topMenu";
import { useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { SearchOutlined } from "@ant-design/icons";

function ViewAllReportsList() {
  const location = useLocation();
  const dispatch = useDispatch();
  const projectName = location.state?.projectName || "Project Reports";
  const { data: allowedRoutes }: any = useSelector(
    (state: RootState) => state.allowedRoutes
  );
  const { data: SideNavCollapse } = useSelector(
    (state: any) => state.SideNavCollapseStatus
  );
  const navigate = useNavigate();
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [searchText, setSearchText] = useState("");

  // Scroll to top when component mounts or when navigating to this page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth >= 990) {
      setSm(false);
    }
  };

  useEffect(() => {
    dispatch(
      updateMenuData(
        TopMenu?.projectNav?.map((item: any) => {
          return {
            ...item,
            linkState: location.state,
          };
        })
      )
    );
  }, [location]);

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  // Original reports data
  const allReports = [
    {
      key: "1",
      reportName: "Task Reassignment Report",
      reportType: "Monitor task ownership changes and reasons.",
      createdBy: "System Generated",
      onClickNavigation: "/pms/task-reassignment-reports-list",
    },
    {
      key: "2",
      reportName: "Task Aging Report",
      reportType: "Identify old and stagnant tasks.",
      createdBy: "System Generated",
      onClickNavigation: "/pms/task-aging-report",
    },
    // {
    //   key: "3",
    //   reportName: "Unassigned Task Report",
    //   reportType: "Detect Pending Assignments",
    //   createdBy: "System Generated",
    //   onClickNavigation: "/pms/unassigned-task-report",
    // },
    {
      key: "4",
      reportName: "Checklist Adherence by User Report",
      reportType: "Track compliance of users to checklist items.",
      createdBy: "System Generated",
      onClickNavigation: "/pms/checklist-adherence-by-user-report",
    },
    {
      key: "5",
      reportName: "Onhold Tasks & Root Cause Report",
      reportType: "Detect task blockages and bottlenecks",
      createdBy: "System Generated",
      onClickNavigation: "/pms/onhold-tasks-report",
    },
    {
      key: "6",
      reportName: "Approvals & Action Delays Report",
      reportType: "Track Delayed user response",
      createdBy: "System Generated",
      onClickNavigation: "/pms/approvals-action-delays-report",
    },
    {
      key: "7",
      reportName: "Tag-Wise Task Performance Report",
      reportType: "Track Task Performance Grouped by Functional Tags",
      createdBy: "System Generated",
      onClickNavigation: "/pms/tagwise-task-performance-report",
    },
    {
      key: "8",
      reportName: "Status-Wise Task Performance Report",
      reportType: "Track Task Performance Grouped by Functional Tags",
      createdBy: "System Generated",
      onClickNavigation: "/pms/statuswise-task-performance-report",
    },
    {
      key: "9",
      reportName: "Work Category Wise Task Performance Report",
      reportType: "Track Task Performance Grouped by Functional Tags",
      createdBy: "System Generated",
      onClickNavigation: "/pms/work-category-wise-task-performance-report",
    },
    {
      key: "10",
      reportName: "Phase Level Progress Summary Report",
      reportType: "Track overall progress of each phase across projects",
      createdBy: "System Generated",
      onClickNavigation: "/pms/phase-level-progress-summary-report",
    },
    {
      key: "11",
      reportName: "Activity Level Progress Summary Report",
      reportType: "Track detailed progress of activities within phases",
      createdBy: "System Generated",
      onClickNavigation: "/pms/activity-level-progress-summary-report",
    },
    {
      key: "12",
      reportName: "Task Level Progress Summary Report",
      reportType: "Mointor task-level execution status",
      createdBy: "System Generated",
      onClickNavigation: "/pms/task-completion-report",
    },
    {
      key: "13",
      reportName: "Issue Tracker",
      reportType: "Capture on-ground execution and blockers",
      createdBy: "System Generated",
      onClickNavigation: "/pms/task-issue-tracker",
    },
    {
      key: "14",
      reportName: "Baseline Vs Current Timeline Report",
      reportType: "Compare Planned vs actual execution",
      createdBy: "System Generated",
      onClickNavigation: "/pms/baseline-current-timeline-report",
    },
    {
      key: "15",
      reportName: "Dependency Violation Report",
      reportType: "Track broken dependencies and lags",
      createdBy: "System Generated",
      onClickNavigation: "/pms/dependency-violation-report",
    },
    {
      key: "16",
      reportName: "User-Wise Workload Report",
      reportType:
        "Evaluate task distribution, workload intensity, user-level Ownership ",
      createdBy: "System Generated",
      onClickNavigation: "/pms/userwise-workload-report",
    },
    {
      key: "17",
      reportName: "User-Wise Planned vs Actual Report",
      reportType: "Analyze planned estimates vs actual contribution by user",
      createdBy: "System Generated",
      onClickNavigation: "/pms/userwise-planned-actuals-report",
    },
    {
      key: "18",
      reportName: "Time Log Reports",
      reportType: "Log and analyze time spent",
      createdBy: "System Generated",
      onClickNavigation: "/pms/time-log-reports",
    },
    // {
    //   key: "19",
    //   reportName: "Petty Cash Inflow/Outflow Report",
    //   reportType: "Track field-level cash usage",
    //   createdBy: "System Generated",
    //   onClickNavigation: "/pms/petty-cash-inflow-outflow-report",
    // },
    {
      key: "19",
      reportName: "Daily Progress Digest",
      reportType: "Daily Site Update.",
      createdBy: "System Generated",
      onClickNavigation: "/pms/daily-progress-digest",
    },
    {
      key: "20",
      reportName: "Time Log Analysis Report",
      reportType:
        "Analyze time spent by team members at various levels of the hierarchy.",
      createdBy: "System Generated",
      onClickNavigation: "/pms/task-wise-timelogs",
    },
    {
      key: "21",
      reportName: "3M Consolidation Report",
      reportType:
        "Project-level Material / Manpower / Machinery allocation rollup across Phases, Activities and Tasks.",
      createdBy: "System Generated",
      onClickNavigation: "/pms/project/3m-consolidation",
    },
  ];

  // Filter reports based on search text and allowed routes
  const filteredReports = useMemo(() => {
    return allReports
      .filter((report) =>
        allowedRoutes.includes(report.onClickNavigation.slice(1))
      )
      .filter((report) => {
        if (!searchText) return true;
        const searchLower = searchText.toLowerCase().trim();
        return (
          report.reportName.toLowerCase().includes(searchLower) ||
          report.reportType.toLowerCase().includes(searchLower)
        );
      });
  }, [searchText, allowedRoutes]);

  return (
    <>
      <Head title="View All Reports" />
      <Content>
        <Card className="card-bordered" style={{ minHeight: "85vh" }}>
          <div className="card-aside-wrap">
            <div className="card-inner card-inner-lg">
              <h5 style={{ marginBottom: "20px", fontWeight: "600" }}>
                {projectName} / Reports
              </h5>
              {/* Search Input */}
              <div style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Search reports by name or description..."
                  prefix={<SearchOutlined />}
                  allowClear
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ width: 400, maxWidth: "100%" }}
                />
              </div>

              <div className="content clearfix">
                <div
                  style={{
                    width: screenSize - (SideNavCollapse ? 120 : 320) + "px",
                    margin: "0px auto",
                  }}
                >
                  <Table
                    className="customTable"
                    columns={[
                      {
                        title: "#",
                        key: "key",
                        width: 50,
                        render: (text, record, index) => index + 1,
                      },
                      {
                        title: "Report Name",
                        dataIndex: "reportName",
                        key: "reportName",
                        render: (text, record: any) => (
                          <span
                            className="inlineTableCellLink"
                            onClick={() =>
                              navigate(record?.onClickNavigation, {
                                state: {
                                  id: location.state?.id,
                                  projectName: location.state?.projectName,
                                  // Explicitly exclude phaseIds, activityIds, phaseName, activityName to ensure clean state
                                },
                              })
                            }
                          >
                            {text}
                          </span>
                        ),
                      },
                      {
                        title: "Report Description",
                        dataIndex: "reportType",
                        key: "reportType",
                      },
                    ]}
                    dataSource={filteredReports}
                    locale={{
                      emptyText: (
                        <span
                          style={{
                            height: "300px",
                            color: "#333",
                            fontSize: "16px",
                          }}
                        >
                          {searchText ? (
                            "No reports found matching your search."
                          ) : (
                            <>
                              Kindly contact the Admin to request access
                              permission for the <b>{"Reports"}</b> module.
                            </>
                          )}
                        </span>
                      ),
                    }}
                    bordered
                    size="middle"
                    pagination={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </Card>
      </Content>
    </>
  );
}

export default ViewAllReportsList;
